import ProductInvoicesHtml from './templates/product-invoices.html'

export function ProductInvoicesDirective () {
  return {
    controller: 'ProductInvoicesCtrl',
    restrict: 'E',
    templateUrl: ProductInvoicesHtml,
    scope: {
      invoices: '=',
      product: '='
    }
  }
};